module.exports = __webpack_public_path__ + "static/media/wenhao.8aac60bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wenhao.png
// module id = 126
// module chunks = 0 1